import { z } from 'zod';
import { emailSchema } from './email.js';

export const forgotPasswordSchema = z.object({
  email: emailSchema(),
  redirect_to: z.string(),
});

export type ForgotPasswordPayload = z.infer<typeof forgotPasswordSchema>;
